// =====================
// SCHEDULE UI RENDER MODULE
// =====================
import { catalog } from '../admin-globals.js';
import {
  slotBgColor, 
  slotAccentColor, 
  ytThumb, 
  fmtDuration, 
  fmtTime, 
  escHtml 
} from '../core/schedule-utils.js';
import { getNowPlaying, computeDaySchedule } from '../core/schedule-engine.js';
import { _scheduleNowMap } from '../admin-globals.js';

export function updateScheduleProgress() {
  const channels = catalog.filter(ch => ch.sync && ch.videos.length > 0 && ch.videos.some(v => v.duration > 0));
  let needsRerender = false;
  channels.forEach(ch => {
    const np = getNowPlaying(ch);
    const title = np?.vid?.title || '';
    if (_scheduleNowMap[ch.num] !== title) { _scheduleNowMap[ch.num] = title; needsRerender = true; }
  });
  if (needsRerender) { renderSchedule(); return; }
  channels.forEach(ch => {
    const np = getNowPlaying(ch);
    if (!np) return;
    const bar = document.getElementById(`sch-bar-${ch.num}`);
    const rem = document.getElementById(`sch-rem-${ch.num}`);
    if (bar) bar.style.width = ((np.elapsed / np.total) * 100).toFixed(1) + '%';
    if (rem) rem.textContent = fmtDuration(np.total - np.elapsed) + ' rest.';
  });
}

export function renderSchedule() {
  const el = document.getElementById('schedule-view');
  const channels = catalog.filter(ch => ch.sync && ch.videos.length > 0 && ch.videos.some(v => v.duration > 0));

  channels.forEach(ch => {
    const np = getNowPlaying(ch);
    _scheduleNowMap[ch.num] = np?.vid?.title || '';
  });

  if (channels.length === 0) {
    el.innerHTML = `
      <div id="schedule-epg-header"><div class="schedule-title"> EN ANTENA</div></div>
      <div style="color:rgba(255,255,255,0.2);font-size:13px;letter-spacing:2px;padding:60px;text-align:center">
        SIN CANALES CON SYNC ACTIVO Y DURACIONES CONFIGURADAS
      </div>`;
    return;
  }

  let cardsHtml = '';
  channels.forEach(ch => {
    const np = getNowPlaying(ch);
    if (!np) return;
    const { vid, elapsed, total } = np;
    const pct = (elapsed / total * 100).toFixed(1);
    const remaining = total - elapsed;
    const thumb = ytThumb(vid);
    const key = vid.title + (vid.id || vid.url || '');
    const bgColor = slotBgColor(key);
    const bgImg = thumb ? `background-image:url('${thumb}');background-size:cover;background-position:center;` : '';
    const videos = ch.videos.filter(v => (v.duration || 0) > 0);
    const currIdx = videos.findIndex(v => v === vid);
    const nextVid =
      videos.length && currIdx >= 0
        ? videos[(currIdx + 1) % videos.length]
        : videos[0] || null;
    const chIdx = catalog.indexOf(ch);

    const isLocal = vid.type !== 'youtube' && vid.url;
    const scanDelay = (Math.random() * 4).toFixed(2);
    cardsHtml += `
      <div class="sch-card">
        <div class="sch-card-thumb" style="background-color:${bgColor};${bgImg};cursor:pointer; position:relative; overflow:hidden" onclick="openWatchModal(${chIdx})">
          ${isLocal ? `<video class="sch-card-video" src="${escHtml(vid.url)}" muted playsinline preload="auto" data-elapsed="${elapsed.toFixed(1)}"></video>` : ''}
          ${vid.type === 'youtube' && vid.id ? `<iframe class="sch-card-yt" src="https://www.youtube.com/embed/${vid.id}?autoplay=1&start=${Math.floor(elapsed)}&mute=1&controls=0&rel=0&modestbranding=1&loop=0&playlist=${vid.id}" allow="autoplay; encrypted-media" allowfullscreen></iframe>` : ''}
          <div class="sch-card-vignette"></div>
          <div class="sch-card-scanlines"></div>
          <div class="sch-card-scanbeam" style="--scan-delay:-${scanDelay}s"></div>
          <div class="sch-card-thumb-overlay"></div>
          <div class="sch-card-ch-badge" style="color:${ch.color}">CH ${ch.num}</div>
          <div class="sch-card-type-badge">${vid.type === 'youtube' ? 'YT' : ' LIVE'}</div>
          <div class="sch-card-led"></div>
          <div class="sch-card-title-overlay">
            <div class="sch-card-title">${escHtml(vid.title)}</div>
            <div class="sch-card-time-info">${fmtDuration(elapsed)} / ${fmtDuration(total)}</div>
          </div>
        </div>
        <div class="sch-card-body" onclick="openAgenda(${chIdx})" style="cursor:pointer">
          <div class="sch-card-progress-wrap">
            <div class="sch-card-bar">
              <div class="sch-card-bar-fill" id="sch-bar-${ch.num}" style="width:${pct}%;background:${ch.color}"></div>
            </div>
            <span class="sch-card-remaining" id="sch-rem-${ch.num}">${fmtDuration(remaining)} rest.</span>
          </div>
          <div class="sch-card-next">&nbsp; siguiente&nbsp;&nbsp; ${escHtml(nextVid ? nextVid.title : '')}</div>
          <div class="sch-card-footer">
            <span style="color:rgba(255,255,255,0.18);font-size:9px;letter-spacing:1px" onclick="event.stopPropagation();openWatchModal(${chIdx})"> VER CANAL</span>
            <span class="sch-card-see-agenda">VER AGENDA </span>
          </div>
        </div>
      </div>`;
  });

  el.innerHTML = `
    <div id="schedule-epg-header">
      <div class="schedule-title"> EN ANTENA</div>
      <span style="font-size:9px;color:rgba(255,255,255,0.2);letter-spacing:2px;font-family:'Share Tech Mono',monospace">SYNC  EPOCH UTC</span>
    </div>
    <div id="schedule-now-grid">${cardsHtml || '<div style="padding:60px;color:rgba(255,255,255,0.2);text-align:center;letter-spacing:2px">SIN DATOS</div>'}</div>
    <div id="schedule-agenda"></div>`;

  el.querySelectorAll('.sch-card-video').forEach(v => {
    const target = parseFloat(v.dataset.elapsed) || 0;
    v.addEventListener('loadedmetadata', () => {
      v.currentTime = target;
      v.play().catch(() => {});
    }, { once: true });
    if (v.readyState >= 1) {
      v.currentTime = target;
      v.play().catch(() => {});
    }
  });
}

export function openAgenda(chIdx) {
  const ch = catalog[chIdx];
  const gridEl = document.getElementById('schedule-now-grid');
  const agendaEl = document.getElementById('schedule-agenda');
  if (!gridEl || !agendaEl) return;

  gridEl.style.display = 'none';
  agendaEl.style.display = 'flex';

  const WINDOW = 2 * 3600;
  const _nowSec = Date.now() / 1000;
  const secsNow = _nowSec - Math.floor(_nowSec / 86400) * 86400;
  const windowStart = secsNow - WINDOW;
  const windowEnd   = secsNow + WINDOW;

  const allSlots = computeDaySchedule(ch, Math.ceil(windowEnd) + 1);
  const slots = allSlots.filter(sl => sl.t + sl.slotDur > windowStart && sl.t < windowEnd);

  let listHtml = '';
  slots.forEach(sl => {
    const key = sl.vid.title + (sl.vid.id || sl.vid.url || '');
    const dot = slotAccentColor(key);
    const cls = sl.isNow ? 'agenda-row agenda-row-now' : sl.isPast ? 'agenda-row agenda-row-past' : 'agenda-row';
    listHtml += `
      <div class="${cls}" style="--now-color:${ch.color}" ${sl.isNow ? 'id="agenda-now-item"' : ''}>
        <span class="agenda-time">${fmtTime(sl.t)}</span>
        <div class="agenda-dot" style="background:${dot}"></div>
        <span class="agenda-title">${escHtml(sl.vid.title)}</span>
        ${sl.isNow ? `<span class="agenda-now-badge" style="border-color:${ch.color};color:${ch.color}">EN ANTENA</span>` : ''}
        <span class="agenda-dur">${fmtDuration(sl.slotDur)}</span>
      </div>`;
  });

  agendaEl.innerHTML = `
    <div id="agenda-header">
      <button id="agenda-back-btn" onclick="closeAgenda()"> VOLVER</button>
      <div id="agenda-ch-title" style="color:${ch.color}">CH ${ch.num}  ${escHtml(ch.name)}</div>
      <div id="agenda-stats">${slots.length} VÍDEOS  2H</div>
    </div>
    <div id="agenda-list">${listHtml}</div>`;

  setTimeout(() => {
    const nowItem = document.getElementById('agenda-now-item');
    if (nowItem) nowItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 80);
}

export function closeAgenda() {
  const gridEl = document.getElementById('schedule-now-grid');
  const agendaEl = document.getElementById('schedule-agenda');
  if (gridEl) gridEl.style.display = '';
  if (agendaEl) agendaEl.style.display = 'none';
}
